import { b64url, utf8 } from "./b64";

export type Jwk = JsonWebKey & { kid?: string };

export async function serviceClientKey(): Promise<{ publicJwks: { keys: Jwk[] }; privateJwk: Jwk }> {
  const pair = await crypto.subtle.generateKey({ name: "ECDSA", namedCurve: "P-256" }, true, ["sign", "verify"]);
  const privateJwk = await crypto.subtle.exportKey("jwk", pair.privateKey);
  const { kty, crv, x, y } = await crypto.subtle.exportKey("jwk", pair.publicKey);
  const kid = b64url(await crypto.subtle.digest("SHA-256", utf8(JSON.stringify({ crv, kty, x, y }))));
  const publicJwk: Jwk = { kty, crv, x, y, kid, alg: "ES256", use: "sig" };
  return { publicJwks: { keys: [publicJwk] }, privateJwk: { ...privateJwk, kid, alg: "ES256" } };
}

export function download(name: string, value: unknown): void {
  const url = URL.createObjectURL(new Blob([JSON.stringify(value, null, 2)], { type: "application/json" }));
  const a = Object.assign(document.createElement("a"), { href: url, download: name });
  a.click();
  URL.revokeObjectURL(url);
}
